import { adminRepositories } from "data/admin/repositories";

export const subscriptionsRepo = {
  list(params) {
    return adminRepositories.subscriptions.list(params);
  },

  getById(id) {
    return adminRepositories.subscriptions.getById(id);
  },

  create(sub) {
    return adminRepositories.subscriptions.create(sub);
  },

  update(id, patch) {
    return adminRepositories.subscriptions.update(id, patch);
  },

  remove(id) {
    return adminRepositories.subscriptions.remove(id);
  },

  restore(id) {
    return adminRepositories.subscriptions.restore(id);
  },
};
